import styled from 'styled-components';

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const Flex = styled.div`
	display: flex;
`;

/**
 * A vertical flex layout which will grow to full width of its container
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const FlexColumn = styled(Flex)`
	flex-direction: column;
	width: 100%;
`;

/**
 * A vertical flex layout which will grow to full width of its container, with center-aligned children
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const FlexColumnCentered = styled(FlexColumn)`
	align-items: center;
`;

/**
 * A horizontal flex layout
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const FlexRow = styled(Flex)`
	flex-direction: row;
`;

/**
 * A horizontal flex layout where the row items will be aligned to the top of the row
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const FlexRowTop = styled(FlexRow)`
	align-items: flex-start;
`;

/**
 * A horizontal flex layout where the row items will be aligned to the BOTTOM of the row
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const FlexRowBottom = styled(FlexRow)`
	align-items: flex-end;
`;

/**
 * Used to put some margin spacing on the left/right sides, but not on the top
 * @deprecated Apply tokenized mx to an existing component through its supported props or sx. Add Box only when a wrapper is needed.
 */
export const Inset = styled.div`
	margin-left: 1rem;
	margin-right: 1rem;
`;

/**
 * Used to put some margin spacing on the top/bottom sides, but not on the left or right.
 * @deprecated Apply tokenized my to an existing component through its supported props or sx. Add Box only when a wrapper is needed.
 */
export const VerticalInset = styled.div`
	margin-top: 1rem;
	margin-bottom: 1rem;
`;

/**
 * Display a row of content with items are evenly distributed in the line, center aligned
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const SpaceBetweenRow = styled(FlexRow)`
	width: 100%;
	align-items: center;
	justify-content: space-between;
`;

/**
 * Display a row of content with items are evenly distributed in the line, center aligned
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const SpaceBetweenRowSmallGap = styled(SpaceBetweenRow)`
	gap: 0.5rem;
`;

/**
 * Display a row of content with items are evenly distributed in the line, center aligned, with a gap of 1rem
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const SpaceBetweenRowGap = styled(SpaceBetweenRow)`
	gap: 1rem;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const SpaceBetweenWrapRow = styled(SpaceBetweenRow)`
	flex-wrap: wrap;
	gap: 0.5rem;
`;

/**
 * Display a row of content with items evenly spaced around in the line, center aligned
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const SpaceAroundRow = styled(FlexRow)`
	width: 100%;
	align-items: center;
	justify-content: space-around;
`;

/**
 * A horizontal flex layout where the items are all centre aligned, expanding to the full width of the container
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const CentredFlexRow = styled(FlexRow)`
	width: 100%;
	align-items: center;
	justify-content: center;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const SpaceEvenRow = styled(FlexRow)`
	align-items: center;
	justify-content: space-evenly;
`;
/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const SpaceEvenRowSmallGap = styled(SpaceEvenRow)`
	gap: 0.5rem;
`;

/**
 * A horizontal row where there is a 1rem gap between items
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const FlexRowSpaced = styled(FlexRow)`
	gap: 1rem;
`;

/**
 * A horizontal row where there is a 1rem gap between items, with items top-aligned
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const FlexRowTopSpaced = styled(FlexRowSpaced)`
	align-items: flex-start;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexWrapRowSpaced = styled(FlexRowSpaced)`
	flex-wrap: wrap;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexRowSpacedLarge = styled(FlexRowSpaced)`
	gap: 2rem;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexColumnSpaced = styled(FlexColumn)`
	gap: 1rem;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexColumnSpacedLarge = styled(FlexColumn)`
	gap: 2rem;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexColumnSmallSpaced = styled(FlexColumn)`
	gap: 0.5rem;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexColumnMiniSpaced = styled(FlexColumn)`
	gap: 0.25rem;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexRowSmallSpaced = styled(FlexRow)`
	gap: 0.5rem;
`;
/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexWrapRowSmallSpaced = styled(FlexRowSmallSpaced)`
	flex-wrap: wrap;
`;
/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexRowCenterAligned = styled(FlexRow)`
	align-items: center;
`;
/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexRowCenterJustify = styled(FlexRow)`
	justify-content: center;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexRowCentered = styled(FlexRowCenterJustify)`
	align-items: center;
	height: 100%;
`;
/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexRowSmallSpacedCentered = styled(FlexRow)`
	gap: 0.5rem;
	align-items: center;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexRowSpacedCentered = styled(FlexRow)`
	gap: 1rem;
	align-items: center;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexWrapRowSpacedCentered = styled(FlexRowSpacedCentered)`
	flex-wrap: wrap;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const FlexColumnFitContent = styled(FlexColumn)`
	width: fit-content;
`;

/** A toolbar used to right-align the buttons, with a gap */
/**
 * Renamed this as it's not only used for toolbars
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const FlexRowSpacedRightAligned = styled(FlexRow)`
	justify-content: flex-end;
	gap: 1rem;
	width: 100%;
`;

/**
 * A horizontal row where the items are left-aligned
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const FlexRowLeftAligned = styled(FlexRow)`
	justify-content: flex-start;
`;

/** @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed. */
export const VerticalContent = styled(FlexColumnSpaced)`
	padding: 0.5rem 1rem 0 1rem;
`;

export const EllipsisSpan = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
`;
/**
 * A full-height padded flex column designed for drawers that have navigation buttons at the bottom.
 * @deprecated Use an existing component's layout and tokenized spacing props, or Stack from @fox/atoms when a layout container is needed.
 */
export const DrawerFlexColumn = styled(FlexColumn)`
	padding: 1rem;
	height: 100%;
`;
